import styled from "styled-components";
import { FaSearch } from "react-icons/fa";

export const ContainerInputPesquisa = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  margin-top: 16px;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 178px;
`;

export const InputPesquisa = styled.input`
  width: 100%;
  padding-left: 30px; /* espaço para o ícone */
  padding-right: 10px;
  height: 36px;
  border: 1px solid #ccc;
  border-radius: 4px;

  &:focus {
    outline: none;
    border-color: #ccc;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const Icon = styled(FaSearch)`
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  color: #999;
  pointer-events: none;
  width: 12px;
`;

export const ContainerTable = styled.div``;

export const ContainerFechar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

export const ContainerValorTotal = styled.div`
padding: 7px 0;
  font-size: 16px;
`;
